import { useState } from 'react';
import { api, ApiRequestError } from '@/lib/api.js';
import { useParamsStore } from '@/stores/paramsStore.js';
import { useViewStore } from '@/stores/viewStore.js';
import { Button } from '@/components/ui/Button.js';

export function ShareButton() {
  const [slug, setSlug] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function share() {
    setBusy(true); setErr(null); setCopied(false);
    try {
      const params = useParamsStore.getState().params;
      const paletteId = useViewStore.getState().paletteId;
      const renderMode = useViewStore.getState().renderMode;
      const { slug } = await api.worlds.create({ params, paletteId, renderMode });
      setSlug(slug);
      const url = `${location.origin}/world/${slug}`;
      history.replaceState(null, '', `/world/${slug}`);
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
      } catch {
        /* clipboard unavailable — URL is still in address bar */
      }
    } catch (e) {
      setErr(e instanceof ApiRequestError ? e.message : 'Share failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Button onClick={share} disabled={busy}>{busy ? 'Sharing…' : 'Share'}</Button>
      {slug && (
        <span role="status" aria-live="polite" className="text-xs text-neutral-400">
          /world/{slug}{copied ? ' copied' : ' — copy from URL bar'}
        </span>
      )}
      {err && <span role="status" aria-live="polite" className="text-xs text-red-400">{err}</span>}
    </div>
  );
}
